"use strict";

module.exports = function (value) {
  if (this.$scopedSlots && this.$scopedSlots['__group_meta']) {
    var data = this.opts.groupMeta.find(function (val) {
      return val.value === value;
    });
    if (!data) return '';
    return this.$scopedSlots['__group_meta'](data);
  }

  return '';
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/get-group-slot.js
// module id = 1611
// module chunks = 61